import type { Collection } from "../lib/types/schema/collection/collectionSchema";

type GetIsCollectionAlbumOnlyWithSongsProps = {
  collection: Collection;
};

export const getIsCollectionAlbumOnlyWithSongs = ({
  collection,
}: GetIsCollectionAlbumOnlyWithSongsProps) => {
  if (!collection.is_album) return false;

  return collection.prayers.every((prayer) => prayer.is_song);
};
